module.exports = __webpack_public_path__ + "static/media/Omen.52e00704.jpeg";